import { Component, ElementRef, Input } from '@angular/core';
import { AppscriptsPaymentRequestBalanceHistory } from '../../shared/models/appscripts-payment-request.model';

@Component({
  standalone: false,
  selector: 'app-appscripts-balance-card',
  templateUrl: './appscripts-balance-card.component.html',
})
export class AppscriptsBalanceCardComponent {
  @Input() balanceHistory: AppscriptsPaymentRequestBalanceHistory[] = [];

  constructor(protected elementRef: ElementRef) {}

  getBalanceSum(type = null) {
    let sum = 0;
    this.balanceHistory.forEach(t => {
      if (type && type !== t.type) {return;}
      sum += t.value;
    });
    return sum === 0 ? 0 : (sum / 100);
  }
}
